import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  WccAssignPlanApi,
  PlansOrderCreateApi,
  PlansVerifyPaymentApi,
  PlansEmailVerifyApi,
} from "../../services/Api";
import { useLocation, useNavigate } from "react-router-dom";

function WccPlanBuy() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { planId,amount } = state;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter an email address");
      return;
    }

    setLoading(true);
    const response = await PlansEmailVerifyApi(email);
    setLoading(false);

    if (response.status === "success") {
      toast.success(response.message);
      handlePay(response.data.id);
    } else if (response.status === "failed" || response.status === "failure") {
      toast.error(response.message);
      navigate("/login");
    } else {
      toast.error(response?.message || "Email validation failed");
    }
  };

  const handlePay = async (userId) => {
    console.log("HandlePay Amount", amount);
    const userData = JSON.parse(localStorage.getItem("userData"));
    const name = userData.name;
    const email = userData.email;
    const phone = userData.phoneNumber;
    const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
    const orderType = "USER_PLAN_SUBSCRIPTION";
    try {
      const response = await PlansOrderCreateApi({ amount, orderType, userId });
      const orderId = response.orderId;
      const options = {
        key: razorpayKey,
        amount: amount * 100,
        currency: "INR",
        name: "Good People",
        description: `Talktime amount ${amount}`,
        image:
          "https://goodpeople.live/static/media/logo.160934d3c48e5910d916.png", // Replace with your logo URL
        order_id: orderId,
        handler: async function (data) {
          console.log("Payment Success:", data);
          const paymentId = data.razorpay_payment_id;
          const signature = data.razorpay_signature;
          const response = await PlansVerifyPaymentApi({
            paymentId: paymentId,
            signature: signature,
            orderId: orderId,
          });
          const res = WccAssignPlanApi({ planId, amount ,userId});
          if (res.status === "success") {
            toast.success(res.message);
            navigate("/", { replace: true });
          } else if (res.status === "failure" || res.status === "failed") {
            toast.error(res.message);
          } else {
            toast.error("Something went wrong!");
          }
        },
        prefill: {
          name: name,
          email: email,
          contact: phone,
        },
        notes: {
          address: "GoodPeople Corporate Office",
        },
        theme: {
          color: "#22BBC7",
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.log("Payment Failed:", response);
        // Handle payment failure
      });

      razorpay.open();
    } catch (error) {
      console.log("Payment initialization error:", error);
      alert("Payment initialization failed. Please try again.");
    }
  };

  return (
    <div className="wcc-plan-buy-page">
      <div className="wcc-plan-buy-container">
        <h2 className="wcc-plan-buy-title">Email Verification</h2>
        <form className="wcc-plan-buy-form" onSubmit={handleSubmit}>
          <label htmlFor="wcc-email" className="wcc-plan-buy-label">
            Email Address
          </label>
          <input
            id="wcc-email"
            type="email"
            className="wcc-plan-buy-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
          <button
            type="submit"
            className="wcc-plan-buy-button"
            disabled={loading}
          >
            {loading ? "Verifying…" : "Verify Email"}
          </button>
        </form>
        {/* after successful verification you can render additional UI here */}
      </div>
    </div>
  );
}

export default WccPlanBuy;
